const About = () => (
    <div
      style={{
        padding: '40px',
        fontFamily: "'Poppins', sans-serif",
        color: '#333',
        background: 'linear-gradient(135deg, #6a5acd, #20b2aa)',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          padding: '30px',
          borderRadius: '15px',
          boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
          maxWidth: '800px',
          textAlign: 'center',
        }}
      >
        <h1
          style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            color: '#6a5acd',
            marginBottom: '20px',
          }}
        >
          About Eat Our Shorts
        </h1>
        <p
          style={{
            fontSize: '1.2rem',
            lineHeight: '1.8',
            marginBottom: '30px',
          }}
        >
          Welcome to <strong>Eat Our Shorts</strong>, a communal platform for filmmakers to share their work, 
          receive feedback, and give feedback to others. Whether you're a director, production designer, cinematographer, sound recordist, editor, or just starting out, 
          our community is here to help you improve and connect with like-minded creators.
        </p>
        <h2
          style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#20b2aa',
            marginBottom: '15px',
          }}
        >
          How It Works
        </h2>
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            marginBottom: '30px',
          }}
        >
          <li
            style={{
              fontSize: '1.2rem',
              marginBottom: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                backgroundColor: '#6a5acd',
                borderRadius: '50%',
                marginRight: '10px',
              }}
            ></span>
            Sign up and upload your films.
          </li>
          <li
            style={{
              fontSize: '1.2rem',
              marginBottom: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                backgroundColor: '#6a5acd',
                borderRadius: '50%',
                marginRight: '10px',
              }}
            ></span>
            Earn tokens by giving feedback on others' films.
          </li>
          <li
            style={{
              fontSize: '1.2rem',
              marginBottom: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                backgroundColor: '#6a5acd',
                borderRadius: '50%',
                marginRight: '10px',
              }}
            ></span>
            Spend tokens to get feedback on your films.
          </li>
        </ul>
        <h2
        style={{
          fontSize: '2rem',
          fontWeight: 'bold',
          color: '#20b2aa',
          marginBottom: '15px',
        }}
      >
        Support the Platform
      </h2>
        <p
        style={{
          fontSize: '1.2rem',
          lineHeight: '1.8',
        }}
      >
        Eat Our Shorts is free to use for everyone. If you'd like to support the platform and get more advice on your filmmaking, 
        you can purchase extra tokens. Your support helps us maintain and improve the platform for the filmmaking community.
      </p>
    </div>
    </div>
  );
  
  export default About;